import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';


// Guarding
import { AuthGuard } from './shared/services/guards/auth.guard';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: SimpleLayoutComponent,
    data: {
      title: 'DevPark'
    },
    children: [
      {
        path: 'login',
        loadChildren: './login/login.module#LoginModule'
      },     
      {
        path: 'pages',
        loadChildren: './pages/pages.module#PagesModule',
      },

    ]
  },













  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'myBiz'
    },

    children: [
      {
        path: 'home',
        loadChildren: './home/home.module#HomeModule',
        canActivate: [AuthGuard], 
      },
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuard], 
      },
        {
        path: 'customers',
        loadChildren: './customers/customer.module#CustomerModule',
        canActivate: [AuthGuard]

      },

      {
        path: 'sales',
        loadChildren: './sales/sales.module#SalesModule',
        canActivate: [AuthGuard], 
      },
    ]
  },




  // otherwise redirect to pages / 
  {
    path: "**",
    redirectTo: "pages/404"  
  }










];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
















// // All the Components that Require Routing
// import { HomeComponent } from './views/home/home.component';
// import { DashboardComponent } from './views/dashboard/dashboard.component';
// import { LoginComponent } from './views/login/login.component';
// import { WeatherComponent } from './views/weather/weather.component';
// import { CustomersComponent } from './views/customers/customers.component';
// import { AddCustomerComponent } from './views/customers/add-customer.component';


// const routeConfig: Routes = [

//     { path: '', redirectTo: 'home', pathMatch: 'full', canActivate: [AuthGuard] },
//     { path: "home", component: HomeComponent, data: { title: 'Devpark' }, canActivate: [AuthGuard] },
//     { path: "dashboard", component: DashboardComponent, canActivate: [AuthGuard] },
//     { path: "login", component: LoginComponent },
//     { path: "weather", component: WeatherComponent, canActivate: [AuthGuard] },
//     { path: "customers", component: CustomersComponent, data: { title: 'Customers' }, canActivate: [AuthGuard] },
//     { path: "addcustomer", component: AddCustomerComponent, data: { title: 'New Customer' }, canActivate: [AuthGuard] },



// ];

// export const AppRouting = RouterModule.forRoot(routeConfig, { useHash: true }); //enableTracing: true






// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/app.routing.ts